import { createVNode } from "vue";
import * as $Icon from "@ant-design/icons-vue";

export default ({ type }) => {
  const $IconArray = $Icon;
  return createVNode($IconArray[type]);
};
